const videoSrc = document.querySelector(".video-placeholder img").dataset.video;
const popUp = `
  <div class="close-x" width="854" height="480">
    <iframe width="854" height="480" class="video-yt" allow="fullscreen;" src="${videoSrc}"></iframe>
  </div>
`;
const newElement = document.createElement("div");
newElement.setAttribute("class", "video-wrapper hidden");

const videoTrigger = document.querySelector(".video-trigger");
const node = document.querySelector(".website-wrapper");

document.body.insertBefore(newElement, node);
newElement.innerHTML = popUp;

const openPopUp = function () {
  newElement.classList.remove("hidden");
  document.body.style = "overflow:hidden";
};

const closePopUp = function () {
  newElement.classList.add("hidden");
  document.body.style = "overflow:auto";
};

videoTrigger.addEventListener("click", openPopUp);
newElement.addEventListener("click", closePopUp);

// const popUp = '<div class="video-wrapper"><iframe width="854" height="480" class="video-yt" src="https://www.youtube.com/embed/UvMwiTibhak?&autoplay=0&loop=1&playlist=UvMwiTibhak&mute=0&controls=1&enablejsapi=1"></iframe></div>';
